import { Box, Button } from '@mui/material'
import { sendGet, sendPost } from '../../hooks/use-fetch'
import { useEffect, useState } from 'react'
import { CheckList } from '../../Components/CheckList'
import { DatePickerWithLabel } from '../../Components/DatePicker'
import { type SelectOption } from '../../Components/SelectWithLabel'
import { toast } from 'react-toastify'

export function FPLQuintileOptions (): JSX.Element {
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [programs, setPrograms] = useState<Array<SelectOption<number>>>([])
  const [selectedPrograms, setSelectedPrograms] = useState<Array<SelectOption<number>>>([])
  const [serviceProviders, setServiceProviders] = useState<Array<SelectOption<number>>>([])
  const [selectedServiceProviders, setSelectedServiceProviders] = useState<Array<SelectOption<number>>>([])

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response } = await sendGet('/Reporting/ISDPrograms', {})
      setPrograms(response)
      const { response: response2 } = await sendGet('/Reporting/ISDServiceProviders', {})
      setServiceProviders(response2)
    }

    void fetchData()
  }, [])

  const openReport = async (): Promise<void> => {
    if (startDate === null || endDate === null) {
      toast.error('Please enter required values.')
    } else {
      const isdServiceProviderIDs: number[] = selectedServiceProviders.map(s => s.id)
      const ISDProgramIDs = selectedPrograms.map(s => s.id)
      const { response, success } = await sendPost('/Reporting/FPLQuintileReportURL', { startDate, endDate, isdServiceProviderIDs, ISDProgramIDs })
      if (success) {
        window.open(response, '_blank')?.focus()
      }
    }
  }

  return <>
    <Box className='mt-10'>
      <DatePickerWithLabel
        required={true}
        label='Start Date'
        name='startDate'
        onChange={setStartDate}
        value={startDate}
      />
      <DatePickerWithLabel
        required={true}
        label='End Date'
        name='endDate'
        onChange={setEndDate}
        value={endDate}
      />

      <CheckList label='Programs' items={programs} selectedItems={selectedPrograms} setSelectedItems={setSelectedPrograms} allOption={true} />

      <CheckList label='Service Providers' items={serviceProviders} selectedItems={selectedServiceProviders} setSelectedItems={setSelectedServiceProviders} allOption={true} />
    </Box>

    <Box className='mt-10'>
      <Button color='secondary' variant='contained' onClick={openReport}>Preview</Button>
    </Box>
  </>
}
